export default __webpack_public_path__ + "static/media/04_rakuten.4a169f04.png";